<script setup>
import { computed, ref } from "vue";
import { meta } from "lib/modules/cat";
import { sortByKey } from "lib/modules/util";
import { methodIcon } from "lib/booking/modules/util";
import { catNames } from "db";
import Card from "lib/srv/components/Card";
import Splash from "views/Splash";
import { addSrvsSchema } from "lib/modules/schema";

const props = defineProps(["srvs", "pcatId", "catId", "ccy"]);

const maxPrice = ref("");
const method = ref(null);
const search = ref("");

const params = new URLSearchParams(location.search);
const ad = params.get("ad");

const cat = meta[`${props.pcatId}/${props.catId}`] || meta[props.pcatId];
const catName = catNames[`${props.pcatId}/${props.catId}`];
const methods = ["video", "phone", "office"];

sortByKey(props.srvs, "^publish");

const _srvs = computed(() => props.srvs.filter((s) => {
	const searchLower = search.value.toLowerCase();

	return (method.value === null || s[method.value]) &&
		   (maxPrice.value === "" || s.price <= maxPrice.value * 100) &&
		   (search.value === "" ||
		    s.title.toLowerCase().includes(searchLower) ||
		    s.descr.toLowerCase().includes(searchLower) ||
		    s.org_name.toLowerCase().includes(searchLower)
		   );
}));

addSrvsSchema(props.srvs, props.ccy);
</script>

<template>
	<Splash
		v-if="ad && cat && cat.splash && cat.splash.ads[ad] && srvs.length > 0"
		:srvs="srvs"
		:ad="ad"
		:cat="cat"
		:pcat-id="pcatId"
		:cat-id="catId"
		:cat-name="catName"
		:ccy="ccy"
	/>
	<div v-else class="page-marketplace">
		<template v-if="cat">
			<h1>{{ $gettext("Find your %1", cat.position) }}</h1>
			<div class="intro">{{ cat.intro }}</div>
		</template>
		<h1 v-else>{{ catName || $gettext("No such category") }}</h1>
		<div class="filters grid gap-16 align-items-end">
			<div class="methods">
				<div class="label">{{ $gettext("Filters") }}</div>
				<div class="vui-radio-group">
					<UiRadioButton
						v-model="method"
						:value="null"
						name="method"
						class="vui-radio-custom compact"
					>
						<span>{{ $gettext("All") }}</span>
					</UiRadioButton>
					<UiRadioButton
						v-for="met in methods"
						:key="met"
						v-model="method"
						:value="met"
						name="method"
						class="vui-radio-custom compact"
					>
						<i :class="methodIcon(met)" class="fa-regular fa-fw"></i>
					</UiRadioButton>
				</div>
			</div>
			<label class="vui-input">
				<div class="input-wrapper">
					<i class="prefix fa-regular fa-money-bill-1"></i>
					<input v-model.number="maxPrice" type="number" :placeholder="$gettext('Max price')">
				</div>
			</label>
			<label class="vui-input">
				<div class="input-wrapper">
					<i class="prefix fa-regular fa-magnifying-glass"></i>
					<input v-model.trim="search" type="text" :placeholder="$gettext('Search')">
				</div>
			</label>
		</div>
		<div v-if="_srvs.length === 0" class="no-services">{{ $gettext("No services found") }}</div>
		<div v-else class="path">
			<a href="">Vixly</a>
			<i class="fa-regular fa-chevron-right"></i>
			<a :href="`category/${pcatId}`">{{ catNames[pcatId] }}</a>
			<i class="fa-regular fa-chevron-right"></i>
			<span>{{ catName }}</span>
		</div>
		<div class="services grid">
			<Card v-for="srv in _srvs" :key="srv.srv_id" :ccy="ccy" :srv="srv"/>
		</div>
		<div v-if="cat" class="steps grid">
			<div class="step">
				<i class="fa-solid fa-circle-1"></i>
				<h2>{{ $gettext("Find") }}</h2>
				<div>{{ cat.find }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-2"></i>
				<h2>{{ $gettext("Book") }}</h2>
				<div>{{ cat.book }}</div>
			</div>
			<div class="step">
				<i class="fa-solid fa-circle-3"></i>
				<h2>{{ $gettext("Meet") }}</h2>
				<div>{{ cat.meet }}</div>
			</div>
		</div>
	</div>
</template>
